import 'client-only';

import { parsedUserAgent } from '@curology/site-tools';
import { useEffect, useMemo, useState } from 'react';

export const useUserAgent = () => {
  const [userAgent, setUserAgent] = useState(null);

  useEffect(() => {
    // @ts-expect-error - TODO: broken by strictNullChecks
    setUserAgent(parsedUserAgent(window?.navigator?.userAgent));
  }, []);

  const isDesktop = useMemo(() => {
    // @ts-expect-error - TODO: broken by strictNullChecks
    const userAgentOsName = userAgent?.os.name;

    if (!userAgentOsName) {
      return false;
    }

    const isWindows = userAgentOsName.indexOf('Windows') !== -1;
    const isMac = userAgentOsName.indexOf('Mac') !== -1;
    return isWindows || isMac;
  }, [userAgent]);

  const isMobile = useMemo(() => {
    // @ts-expect-error - TODO: broken by strictNullChecks
    const isMobileDevice = userAgent?.device.type === 'mobile';
    return isMobileDevice || !isDesktop;
  }, [userAgent, isDesktop]);

  const isSafari = useMemo(() => {
    return (
      // @ts-expect-error - TODO: broken by strictNullChecks
      !!userAgent?.browser.name && userAgent?.browser.name.includes('Safari')
    );
  }, [userAgent]);

  const isIOS = useMemo(() => {
    // @ts-expect-error - TODO: broken by strictNullChecks
    return !!userAgent?.os.name && userAgent?.os.name.includes('iOS');
  }, [userAgent]);

  const isFacebookInApp = useMemo(() => {
    // @ts-expect-error - TODO: broken by strictNullChecks
    const browserName = userAgent?.browser.name || '';
    return browserName.indexOf('Facebook') !== -1;
  }, [userAgent]);

  const isEmbeddediOS = useMemo((): boolean => {
    if (typeof window === 'undefined') {
      return false;
    }

    const navigator = window?.navigator;

    if (!navigator) {
      return false;
    }

    const standAlone =
      'standalone' in navigator && Boolean(navigator.standalone);
    return isIOS && standAlone && isSafari;
  }, [isIOS, isSafari]);

  const isEmbeddedAndroid = useMemo((): boolean => {
    // @ts-expect-error - TODO: broken by strictNullChecks
    return userAgent?.ua.includes('wv') || false;
  }, [userAgent]);

  const isEmbeddedWebView = useMemo((): boolean => {
    if (!isMobile) {
      return false;
    }

    return isEmbeddediOS || isEmbeddedAndroid;
  }, [isEmbeddedAndroid, isEmbeddediOS, isMobile]);

  return {
    isEmbeddedWebView,
    isDesktop,
    isMobile,
    isFacebookInApp,
  };
};
